import React from "react";
import ReactDOM from "react-dom";

// Add formValues and calculatedFee to the props here
export default function OptionsHelpModal({ onClose, formValues, calculatedFee }) {
  const modalContent = (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-container" style={{ maxWidth: '450px' }}>
        <div className="confirm-modal-header">
        OPTIONS GUIDE
        </div>
        
        <div className="confirm-modal-body" style={{ fontSize: '0.75rem', lineHeight: '1.4' }}>
          <p>You are acting as the Seller (Writer). You are creating a contract that allows a buyer to purchase your assets at a locked price.</p>
          
          <div style={{ margin: '15px 0', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div>
              <b style={{ color: '#fff' }}>COLLATERAL:</b> {formValues?.amount || 0} {formValues?.ticker?.toUpperCase() || 'shares'} will be deducted from your account and locked in the contract immediately.
            </div>
            <div>
  <div>
  <b style={{ color: '#fff' }}>STRIKE PRICE:</b> The market price must reach this target for the contract to become exercisable ("In The Money").
</div>
            </div>
            <div>
              <b style={{ color: '#fff' }}>PREMIUM (PREM):</b> The fee you are charging the buyer to own this contract. You receive this only when the contract is purchased.
            </div>
            <div>
              <b style={{ color: '#fff' }}>TAX:</b> An upfront non-refundable fee of <span style={{ color: '#ff4646' }}>${calculatedFee?.toLocaleString() || 0}</span> is charged to issue this contract.
            </div>
            <div>
                <b style={{ color: '#fff' }}>TERM:</b> Once purchased, the buyer has this much time for the price to hit the strike. If the timer hits zero before the strike is met, the contract expires.
            </div>
          </div>

          <p style={{ borderTop: '1px solid rgba(80, 227, 194, 0.2)', paddingTop: '10px', fontSize: '0.65rem', color: '#888' }}>
            WARNING: Collateral is only returned if the contract expires without being purchased or exercised. Taxes are non-refundable.
          </p>
        </div>

        <div className="confirm-modal-actions">
          <button className="modal-btn confirm" onClick={onClose}>
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}